import { configInstance } from '@returnmates/client-core/src/config';
var returnmatesUrlMap = {
    local: 'https://dev.returnmates.com',
    dev: 'https://dev.returnmates.com',
    stage: 'https://stage.returnmates.com',
    prod: 'https://www.returnmates.com',
};
var wilsonUrlMap = {
    local: 'https://admin.dev.returnmates.com',
    dev: 'https://admin.dev.returnmates.com',
    stage: 'https://admin.stage.returnmates.com',
    prod: 'https://wilson.returnmates.com',
};
var partnerUrlMap = {
    local: 'https://{partnerCode}.dev.returnmates.com',
    stage: 'https://{partnerCode}.stage.returnmates.com',
    dev: 'https://{partnerCode}.dev.returnmates.com',
    prod: 'https://{partnerCode}.returnmates.com',
};
var swayTrackingUrlMap = {
    local: 'https://track-dev.shipsway.com',
    dev: 'https://track-dev.shipsway.com',
    stage: 'https://track-stage.shipsway.com',
    prod: 'https://track.shipsway.com',
};
export var RETURNMATES_URL = returnmatesUrlMap[configInstance];
export var WILSON_URL = wilsonUrlMap[configInstance];
export var SWAY_TRACKING_URL = swayTrackingUrlMap[configInstance];
export var partnerUrl = function (partnerCode) {
    return partnerUrlMap[configInstance].replace('{partnerCode}', partnerCode);
};
export var SCHEDULE_PICKUP_SUCCESS = '/schedule-pickup-success';
export var TERMS = '/terms';
export var PRIVACY = '/privacy';
export var PACKAGE_FAQ = '/add-package/faq';
export var WORK_WITH_US = 'https://us-2.fountain.com/c/returnmates/returnmates-8e208966-7907-442e-8bd5-e9ea6a4acb52/US';
//# sourceMappingURL=paths.js.map